export const Data = {
  features: [
    {
      id: 0,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="40"
          viewBox="0 0 52 40"
          fill="none"
        >
          <path
            d="M42.835 3.4667C42.813 3.4667 42.7911 3.46742 42.7692 3.46886C38.0989 3.7768 31.0606 5.59041 27.081 7.51659L27.081 7.51653L27.0711 7.52146L26.7117 7.70031C26.5691 7.76675 26.3127 7.82503 26 7.82503C25.683 7.82503 25.424 7.76516 25.2825 7.69761L25.2825 7.69754L25.2707 7.69207L24.7357 7.44514C20.7564 5.53812 13.7461 3.74304 9.07664 3.45204C7.58435 3.35582 6.18187 3.73788 5.12738 4.48683C4.06755 5.23957 3.33331 6.39227 3.33331 7.7667V27.9C3.33331 29.0605 3.94119 30.0904 4.77806 30.8261C5.62007 31.5663 6.75911 32.0743 8.00255 32.1949L8.62613 32.2611L8.62938 32.2615C13.237 32.7351 20.3988 34.545 24.4639 36.2551C24.4734 36.2591 24.483 36.263 24.4927 36.2667L24.5642 36.2942C25.0098 36.4806 25.523 36.5542 25.9864 36.5542C26.4515 36.5542 26.9703 36.4801 27.4156 36.2844C31.4793 34.5599 38.6529 32.7361 43.2788 32.262C43.2804 32.2618 43.2819 32.2617 43.2834 32.2615L43.9895 32.1957L43.9924 32.1954C45.2378 32.0757 46.3787 31.5673 47.2219 30.8261C48.0588 30.0904 48.6666 29.0605 48.6666 27.9V7.78336C48.6666 6.39812 47.9245 5.24464 46.858 4.49457C45.8055 3.7544 44.4116 3.37811 42.9339 3.4667H42.835Z"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M26.75 9.14996C26.75 8.73575 26.4142 8.39996 26 8.39996C25.5858 8.39996 25.25 8.73575 25.25 9.14996V34.15C25.25 34.5642 25.5858 34.9 26 34.9C26.4142 34.9 26.75 34.5642 26.75 34.15V9.14996Z"
            stroke="#000088"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.7917 14.9C17.2059 14.9 17.5417 14.5642 17.5417 14.15C17.5417 13.7357 17.2059 13.4 16.7917 13.4H11.9167C11.5025 13.4 11.1667 13.7357 11.1667 14.15C11.1667 14.5642 11.5025 14.9 11.9167 14.9H16.7917Z"
            stroke="#000088"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.4167 19.9C18.8309 19.9 19.1667 19.5642 19.1667 19.15C19.1667 18.7357 18.8309 18.4 18.4167 18.4H11.9167C11.5025 18.4 11.1667 18.7357 11.1667 19.15C11.1667 19.5642 11.5025 19.9 11.9167 19.9H18.4167Z"
            stroke="#000088"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      title: `comprehensive study librabry`,
      text: `In CBA Study App you explore a vast collection of pdf resources ranging from journals, short and long articles to textbooks, and reference materials across various subjects, ensuring you have the resources you need to excel in your studies.`,
    },
    {
      id: 1,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="43"
          viewBox="0 0 53 43"
          fill="none"
        >
          <path
            d="M39.3635 13.819C39.4186 13.8266 39.4743 13.8296 39.53 13.8279C42.8852 13.7274 45.8673 11.4168 45.895 8.21448L45.895 8.21448V8.20585C45.895 4.9422 42.7721 2.58334 39.305 2.58334C35.8406 2.58334 32.715 4.92204 32.715 8.20585C32.715 11.4172 35.7065 13.7275 39.0584 13.8279C39.1141 13.8296 39.1697 13.8266 39.2249 13.819C39.2643 13.8136 39.3241 13.8136 39.3635 13.819Z"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <mask
            id="path-2-outside-1_99_28"
            maskUnits="userSpaceOnUse"
            x="34.2034"
            y="15.0206"
            width="16"
            height="14"
            fill="black"
          >
            <rect fill="white" x="34.2034" y="15.0206" width="16" height="14" />
            <path d="M37.2684 25.8717C40.2367 26.2838 43.5084 25.8538 45.805 24.5817C48.86 22.8975 48.86 20.1384 45.805 18.4542C43.4867 17.1821 40.1717 16.7521 37.2034 17.1821" />
          </mask>
          <path
            d="M37.5434 23.8907C36.4493 23.7388 35.4393 24.5026 35.2874 25.5967C35.1355 26.6908 35.8993 27.7008 36.9934 27.8527L37.5434 23.8907ZM45.805 24.5817L44.8395 22.8302L44.836 22.8321L45.805 24.5817ZM45.805 18.4542L46.7706 16.7027L46.7671 16.7008L45.805 18.4542ZM36.9166 15.2028C35.8235 15.3611 35.0657 16.3757 35.224 17.4688C35.3824 18.562 36.3969 19.3198 37.4901 19.1614L36.9166 15.2028ZM36.9934 27.8527C40.2747 28.3082 44.0078 27.8634 46.7741 26.3312L44.836 22.8321C43.0089 23.8441 40.1987 24.2593 37.5434 23.8907L36.9934 27.8527ZM46.7706 26.3332C48.648 25.2982 50.0963 23.636 50.0963 21.5179C50.0963 19.3999 48.648 17.7377 46.7706 16.7027L44.8395 20.2057C46.0171 20.8549 46.0963 21.4144 46.0963 21.5179C46.0963 21.6215 46.0171 22.181 44.8395 22.8302L46.7706 26.3332ZM46.7671 16.7008C43.9817 15.1724 40.2057 14.7263 36.9166 15.2028L37.4901 19.1614C40.1377 18.7779 42.9917 19.1918 44.8429 20.2076L46.7671 16.7008Z"
            fill="#000088"
            mask="url(#path-2-outside-1_99_28)"
          />
          <path
            d="M13.405 13.8279C13.4607 13.8296 13.5164 13.8266 13.5715 13.819C13.6109 13.8136 13.6707 13.8136 13.7101 13.819C13.7653 13.8266 13.8209 13.8296 13.8766 13.8279C17.2286 13.7275 20.22 11.4172 20.22 8.20585C20.22 4.92204 17.0944 2.58334 13.63 2.58334C10.1629 2.58334 7.03998 4.9422 7.03998 8.20585H7.03994L7.04002 8.21448C7.06768 11.4168 10.0498 13.7274 13.405 13.8279Z"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <mask
            id="path-5-outside-2_99_28"
            maskUnits="userSpaceOnUse"
            x="2.83875"
            y="15.0206"
            width="15"
            height="14"
            fill="black"
          >
            <rect fill="white" x="2.83875" y="15.0206" width="15" height="14" />
            <path d="M15.6667 25.8717C12.6983 26.2838 9.42666 25.8538 7.13 24.5817C4.075 22.8975 4.075 20.1384 7.13 18.4542C9.44833 17.1821 12.7633 16.7521 15.7317 17.1821" />
          </mask>
          <path
            d="M15.9417 27.8527C17.0358 27.7008 17.7995 26.6908 17.6477 25.5967C17.4958 24.5026 16.4857 23.7388 15.3916 23.8907L15.9417 27.8527ZM7.13 24.5817L8.09905 22.8321L8.09556 22.8302L7.13 24.5817ZM7.13 18.4542L6.1679 16.7008L6.16443 16.7027L7.13 18.4542ZM15.4449 19.1614C16.5381 19.3198 17.5526 18.562 17.711 17.4688C17.8694 16.3757 17.1115 15.3611 16.0184 15.2028L15.4449 19.1614ZM15.3916 23.8907C12.7363 24.2593 9.92609 23.8441 8.09904 22.8321L6.16095 26.3312C8.92723 27.8634 12.6604 28.3082 15.9417 27.8527L15.3916 23.8907ZM8.09556 22.8302C6.91793 22.181 6.83875 21.6215 6.83875 21.5179C6.83875 21.4144 6.91793 20.8549 8.09556 20.2057L6.16443 16.7027C4.28706 17.7377 2.83875 19.3999 2.83875 21.5179C2.83875 23.636 4.28706 25.2982 6.16443 26.3332L8.09556 22.8302ZM8.09209 20.2076C9.94331 19.1918 12.7974 18.7779 15.4449 19.1614L16.0184 15.2028C12.7293 14.7263 8.95335 15.1724 6.1679 16.7008L8.09209 20.2076Z"
            fill="#000088"
            mask="url(#path-5-outside-2_99_28)"
          />
          <path
            d="M26.3635 27.2027C26.4167 27.21 26.4703 27.2131 26.524 27.2118C29.8898 27.1311 32.8674 24.796 32.895 21.5982L32.895 21.5982V21.5896C32.895 18.3259 29.7721 15.9671 26.305 15.9671C22.8406 15.9671 19.715 18.3058 19.715 21.5896C19.715 24.8009 22.7065 27.1112 26.0584 27.2116C26.1141 27.2133 26.1697 27.2103 26.2249 27.2027C26.2643 27.1973 26.3241 27.1973 26.3635 27.2027Z"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.7145 30.9788L19.7145 30.9788L19.7122 30.9801C18.0098 31.9186 16.9037 33.3051 16.9037 34.9196C16.9037 36.5337 18.0093 37.9199 19.7111 38.8584C21.6298 39.9195 24.0932 40.4211 26.5 40.4211C28.9065 40.4211 31.3697 39.9196 33.2884 38.8588C34.9905 37.9202 36.0962 36.5339 36.0962 34.9196C36.0962 33.3051 34.9902 31.9186 33.2878 30.9801C31.379 29.9278 28.9154 29.4315 26.5081 29.4315C24.1005 29.4315 21.6328 29.9279 19.7145 30.9788Z"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      title: `interactive reading experience`,
      text: `Immerse yourself in our intuitive and user-friendly reading interface, designed to make learning engaging and comfortable.`,
    },
    {
      id: 2,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
        >
          <mask
            id="path-1-outside-1_99_126"
            maskUnits="userSpaceOnUse"
            x="18.5"
            y="1.41666"
            width="8"
            height="15"
            fill="black"
          >
            <rect fill="white" x="18.5" y="1.41666" width="8" height="15" />
            <path d="M20.5 3.41666V13.6667L23.9167 10.25" />
          </mask>
          <path
            d="M22.5 3.41666C22.5 2.31209 21.6046 1.41666 20.5 1.41666C19.3954 1.41666 18.5 2.31209 18.5 3.41666H22.5ZM20.5 13.6667H18.5C18.5 14.4756 18.9873 15.2049 19.7346 15.5144C20.482 15.824 21.3422 15.6529 21.9142 15.0809L20.5 13.6667ZM25.3309 11.6642C26.1119 10.8832 26.1119 9.61682 25.3309 8.83578C24.5498 8.05473 23.2835 8.05473 22.5025 8.83578L25.3309 11.6642ZM18.5 3.41666V13.6667H22.5V3.41666H18.5ZM21.9142 15.0809L25.3309 11.6642L22.5025 8.83578L19.0858 12.2524L21.9142 15.0809Z"
            fill="#000088"
            mask="url(#path-1-outside-1_99_126)"
          />
          <path
            d="M20.5 13.6667L17.0833 10.25"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M25.3667 20.725C25.3212 20.7591 25.2787 20.797 25.2397 20.8384L23.4971 22.6834L23.4943 22.6864C21.8758 24.4147 19.1276 24.4198 17.4874 22.6851C17.4869 22.6845 17.4863 22.684 17.4858 22.6834L15.7637 20.842C15.7238 20.7992 15.6801 20.7601 15.6333 20.725C15.6193 20.7145 15.6053 20.704 15.5913 20.6934C15.1776 20.3829 14.7394 20.054 14.1662 19.8308C13.5618 19.5954 12.8776 19.5 11.9583 19.5C8.44722 19.5 6.29939 20.278 5.15641 21.9325C4.60522 22.7303 4.35816 23.64 4.24019 24.5434C4.12496 25.4258 4.12498 26.3795 4.125 27.296L4.125 27.3333V29.0417L4.125 29.0799C4.12498 30.2306 4.12496 31.4084 4.26689 32.495C4.41155 33.6025 4.71199 34.6963 5.36986 35.6489C6.72625 37.6129 9.30103 38.5833 13.6667 38.5833H27.3333C30.9349 38.5833 33.4035 37.5686 34.9366 35.7187C36.438 33.907 36.875 31.488 36.875 29.0417V27.3333V27.296C36.875 26.3795 36.875 25.4258 36.7598 24.5434C36.6418 23.64 36.3948 22.7303 35.8436 21.9325C34.7006 20.278 32.5528 19.5 29.0417 19.5C28.1224 19.5 27.4382 19.5954 26.8338 19.8308C26.2606 20.054 25.8224 20.3829 25.4087 20.6934C25.3947 20.704 25.3807 20.7145 25.3667 20.725Z"
            stroke="#000088"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <mask
            id="path-5-outside-2_99_126"
            maskUnits="userSpaceOnUse"
            x="5.54166"
            y="3.90167"
            width="11"
            height="19"
            fill="black"
          >
            <rect fill="white" x="5.54166" y="3.90167" width="11" height="19" />
            <path d="M8.54166 20.5V13.6667C8.54166 10.2329 8.54166 7.39709 13.6667 6.90167" />
          </mask>
          <path
            d="M6.54166 20.5C6.54166 21.6046 7.43709 22.5 8.54166 22.5C9.64623 22.5 10.5417 21.6046 10.5417 20.5H6.54166ZM13.8591 8.89239C14.9585 8.78611 15.7637 7.80868 15.6574 6.70924C15.5511 5.60979 14.5737 4.80467 13.4742 4.91095L13.8591 8.89239ZM10.5417 20.5V13.6667H6.54166V20.5H10.5417ZM10.5417 13.6667C10.5417 11.7885 10.5906 10.7912 10.9466 10.1241C11.1508 9.74174 11.6582 9.10515 13.8591 8.89239L13.4742 4.91095C10.5501 5.19361 8.49505 6.22265 7.41792 8.24047C6.49274 9.97364 6.54166 12.1111 6.54166 13.6667H10.5417Z"
            fill="#000088"
            mask="url(#path-5-outside-2_99_126)"
          />
          <mask
            id="path-7-outside-3_99_126"
            maskUnits="userSpaceOnUse"
            x="24.3333"
            y="3.90167"
            width="11"
            height="19"
            fill="black"
          >
            <rect fill="white" x="24.3333" y="3.90167" width="11" height="19" />
            <path d="M32.4583 20.5V13.6667C32.4583 10.2329 32.4583 7.39709 27.3333 6.90167" />
          </mask>
          <path
            d="M30.4583 20.5C30.4583 21.6046 31.3538 22.5 32.4583 22.5C33.5629 22.5 34.4583 21.6046 34.4583 20.5H30.4583ZM27.5258 4.91095C26.4263 4.80467 25.4489 5.60979 25.3426 6.70924C25.2363 7.80868 26.0415 8.78611 27.1409 8.89239L27.5258 4.91095ZM34.4583 20.5V13.6667H30.4583V20.5H34.4583ZM34.4583 13.6667C34.4583 12.1111 34.5073 9.97364 33.5821 8.24047C32.5049 6.22265 30.4499 5.19361 27.5258 4.91095L27.1409 8.89239C29.3418 9.10515 29.8492 9.74174 30.0534 10.1241C30.4094 10.7912 30.4583 11.7885 30.4583 13.6667H34.4583Z"
            fill="#000088"
            mask="url(#path-7-outside-3_99_126)"
          />
        </svg>
      ),
      title: `downloadable resources`,
      text: `Gain access to a wealth of downloadable resources, including lecture notes, handouts, and study guides, to supplement your learning journey.`,
    },
    {
      id: 3,
      icon: (
        <svg
          width="58"
          height="43"
          viewBox="0 0 58 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M43.2 16.7H48.2"
            stroke="#000088"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M45.7 19.2V14.2"
            stroke="#000088"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M45.5 26C50.7467 26 55 21.7467 55 16.5C55 11.2533 50.7467 7 45.5 7C40.2533 7 36 11.2533 36 16.5C36 21.7467 40.2533 26 45.5 26Z"
            stroke="#000088"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M56 27L54 25"
            stroke="#000088"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.8254 12.8514L13.8257 12.8501C14.1935 11.2872 14.6442 9.8834 15.2262 8.69921C16.3631 6.34904 17.9586 4.754 20.1637 3.993C22.3229 3.24783 24.9269 3.35239 27.9996 4.07902C28.0001 4.07913 28.0005 4.07924 28.001 4.07936L30.9903 4.77746L30.9907 4.77753C34.8405 5.67798 37.6081 7.13247 39.1085 9.55093C40.609 11.9694 40.6816 15.0925 39.7811 18.9333L38.0256 26.4208C38.0256 26.4212 38.0255 26.4215 38.0254 26.4219L38.0253 26.4224L37.0517 26.1942C35.5467 32.6621 32.5725 35.2779 26.9825 34.7404L13.8254 12.8514ZM13.8254 12.8514L12.0697 20.358C12.0697 20.3582 12.0697 20.3583 12.0696 20.3585C11.169 24.2002 11.2467 27.3184 12.747 29.734C14.2467 32.1486 17.008 33.6034 20.839 34.513L23.8454 35.2288C23.8458 35.2289 23.8463 35.229 23.8467 35.2291C24.924 35.4891 25.9407 35.6598 26.8947 35.7366L13.8254 12.8514Z"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M27.5434 35.5683C27.8949 35.3302 28.0577 34.896 27.9495 34.4855C27.8412 34.0749 27.4855 33.7775 27.0622 33.7436C26.2273 33.6768 25.3121 33.5254 24.3146 33.2846L24.3116 33.2839L21.3016 32.5672L21.301 32.5671C17.6608 31.7028 15.5308 30.4254 14.446 28.6788C13.3619 26.9334 13.1619 24.4617 14.0169 20.8145L14.0171 20.814L15.7726 13.3082C15.7727 13.3079 15.7727 13.3076 15.7728 13.3073C16.1214 11.8262 16.5302 10.5796 17.0224 9.57883C17.1896 9.23885 17.1503 8.83358 16.9209 8.53204C16.6915 8.23051 16.3114 8.08451 15.9391 8.15494C15.2187 8.29124 14.4762 8.50199 13.7265 8.7397L13.7265 8.73964L13.7161 8.74305L10.8882 9.67377C7.23893 10.8508 4.67668 12.4791 3.42 14.948C2.16379 17.416 2.35109 20.4518 3.52741 24.1002L3.52787 24.1016L5.8212 31.1787L5.82145 31.1795C7.00709 34.8283 8.63507 37.3948 11.1008 38.6563C13.5668 39.9181 16.5988 39.7355 20.2481 38.5588L20.2481 38.5589L20.2539 38.557L23.0823 37.6261C23.0826 37.626 23.0829 37.6259 23.0832 37.6258C24.8361 37.0537 26.3282 36.3915 27.5434 35.5683Z"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22.6467 15.2829L31.3363 17.4867"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.8908 22.2167L26.0867 23.5425"
            stroke="#000088"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      title: `seamless book browsing`,
      text: `Browse and discover a wide selection of academic books and references in various formats, from physical copies to e-books. stay updated with the latest releases and timeless classics.`,
    },
  ],

  services: [
    {
      id: 0,
      title: `effortless note-taking`,
      description: `CBA Study App can highly increase your level of academia vibe to the optimum performance. Take organized and structured notes directly within CBA Study App to enhance retention and comprehension..`,
    },
    {
      id: 1,
      title: `assignment solutions`,
      description: `Struggling with a difficult assignment? Find step-by-step solutions to a wide range of questions and exercises, empowering you to master the material.`,
    },
    {
      id: 2,
      title: `interactive quizzes and practices test`,
      description: `Test your knowledge with interactive quizzes and practice tests tailored to reinforce your understanding and track your progress. From the contents and files perused and explored it can always help to generate an AI question banker to test your level of knowledge on any topic at hand.`,
    },
    {
      id: 3,
      title: `progress tracking`,
      description: `Monitor your progress with detailed insights and analytics to identify strengths and areas for improvement.`,
    },
    {
      id: 4,
      title: `study materials`,
      description: `Dive into our vast repository of digital textbooks, articles, and study guides, carefully curated to support your academic needs. Access content from renowned publishers and educators.`,
    },
    {
      id: 5,
      title: `available bookstore`,
      description: `Browse and discover a wide selection of academic books and references in various formats, from physical copies to e-books. Stay updated with the latest releases and timeless classics.`,
    },
  ],
  contactus: [
    {
      id: 0,
      icon: `/assets/email-icon.svg`,
      title: `email`,
      description: `Email us if you have any question or need assistance`,
      info: `codeblazeacademy@gmail.com`,
    },
    {
      id: 1,
      icon: `/assets/phone-icon.svg`,
      title: `call`,
      description: `To speak with a member of our support team call`,
      info: `09017912839 / 08082182438`,
    },
    {
      id: 2,
      icon: `/assets/head-phone-icon.svg`,
      title: `support and complaints`,
      description: `Check out helpful resources and FAQs`,
      info: `send message`,
    },
  ],
  icons: [
    {
      id: 1,
      imgSrc: `/assets/instagram-icon.svg`,
    },
    {
      id: 2,
      imgSrc: `/assets/video-icon.svg`,
    },
    {
      id: 3,
      imgSrc: `/assets/facebook-icon.svg`,
    },
    {
      id: 4,
      imgSrc: `/assets/twiiter-icon.svg`,
    },
  ],
};
